import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useSearchParameters } from '@xing-com/crate-hooks-use-search-parameters';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useFilter } from '@xing-com/crate-jobs-hooks';
import { SkeletonTag, SkeletonHeadline } from '@xing-com/skeleton';
import { Tag } from '@xing-com/tag';
import { spaceL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import { SINCE_PERIOD_KEY } from '../../../helpers';
import * as S from '../shared.styles';

type Props = { loading?: boolean };
export const TimeFrameFilter: React.FC<Props> = ({ loading }) => {
  const { value: sincePeriod } = useFilter(SEARCH_STATE_PARAMS.sincePeriod);
  const { setSearchParameters } = useSearchParameters();

  if (loading) {
    return <Skeleton />;
  }

  const handleOnClick = (option: string) => (): void => {
    setSearchParameters(
      {
        [SEARCH_STATE_PARAMS.sincePeriod]: option,
        // When selecting any time frame option, we need to clear the since parameter
        [SEARCH_STATE_PARAMS.since]: '',
      },
      { removeEmpty: true }
    );
  };

  return (
    <div role="group" aria-labelledby="time-frame-filter-title">
      <BodyCopy
        size="small"
        fontWeight="bold"
        data-testid="all-filters-filter"
        id="time-frame-filter-title"
      >
        <FormattedMessage id="JOBS_SEARCH_FILTER_TIME_FRAME" />
      </BodyCopy>
      <S.TagsContainer>
        {Object.entries(SINCE_PERIOD_KEY).map(([option, key]) => (
          <Tag
            key={option}
            selected={option === sincePeriod}
            onClick={handleOnClick(option)}
          >
            <FormattedMessage id={key} />
          </Tag>
        ))}
      </S.TagsContainer>
    </div>
  );
};

const TitleSkeleton = styled(SkeletonHeadline)`
  margin-bottom: ${spaceL};
`;

const Skeleton: React.FC = () => (
  <div>
    <TitleSkeleton size="small" amountRows={1} />
    <S.TagsContainer>
      <SkeletonTag />
      <SkeletonTag />
      <SkeletonTag />
    </S.TagsContainer>
  </div>
);
